var _path, _path2, _path3, _path4, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icon-css-uz",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1eb53a",
    d: "M0 320h640v160H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0099b5",
    d: "M0 0h640v160H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 153.6h640v172.8H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 163.2h640v153.6H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.4,
    cy: 76.8,
    r: 57.6,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.6,
    cy: 76.8,
    r: 57.6,
    fill: "#0099b5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "matrix(1.92 0 0 1.92 261.1 122.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0-6L-1.9-.3 1 .7"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "rotate(72)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "rotate(-72)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    transform: "rotate(144)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    y: -24,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    y: -48,
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 24,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 48,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: -48,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: -24,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: -24,
    y: -24,
    xlinkHref: "#d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.6e16292aee6b5262a6938af4ed24792d.svg";
export { ForwardRef as ReactComponent };